<template>
  <el-result icon="success" title="成功提示" subTitle="请根据提示进行操作">
  </el-result>
</template>

<script>
export default {};
</script>

<style>
</style>